import { CUSTOM_EVENTS, STORAGE_KEYS } from '../utils/constants';

export function applyInitialTheme() {
  try {
    const stored = localStorage.getItem(STORAGE_KEYS.THEME);
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    const isDark = stored ? stored === 'dark' : prefersDark;
    setDarkClass(isDark);
  } catch (error) {
    console.error('theme:applyInitialTheme failed to read or apply theme', error);
    // Fallback: default to light
    setDarkClass(false);
  }
}

export function isDarkMode() {
  return document.documentElement.classList.contains('dark');
}

function setDarkClass(enable) {
  const root = document.documentElement;
  if (enable) root.classList.add('dark');
  else root.classList.remove('dark');
}

export function setTheme(mode) {
  const enableDark = mode === 'dark';
  setDarkClass(enableDark);
  try {
    localStorage.setItem(STORAGE_KEYS.THEME, enableDark ? 'dark' : 'light');
  } catch (error) {
    console.error('theme:setTheme failed to persist theme to localStorage', error);
  }
  try {
    window.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.THEME_CHANGE, { detail: { mode } }));
  } catch (error) {
    console.error('theme:setTheme failed to dispatch theme:change event', error);
  }
}

export function toggleTheme() {
  const enableDark = !isDarkMode();
  setTheme(enableDark ? 'dark' : 'light');
}
